import { render, staticRenderFns } from "./EquipmentMaintenance.vue?vue&type=template&id=b96b04d6&scoped=true"
import script from "./EquipmentMaintenance.vue?vue&type=script&lang=js"
export * from "./EquipmentMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96b04d6",
  null
  
)

export default component.exports